import React from 'react';
import { Skeleton } from '@ann/web-components';
import { DashboardListHeader, DashboardCard } from '../../components';
import { TemplateFilters } from '../../components/DashboardFilters';
import { useDashboardData } from '../../context';
import { PageWrapper, FiltersSection, CardsSection } from './TemplateList.styled';

const SKELETON_ITEMS = Array.from({ length: 3 });
const noop = () => {};

const TemplateList = () => {
  const { templates, loadingTemplates } = useDashboardData();

  return (
    <PageWrapper>
      <DashboardListHeader />
      <FiltersSection>
        <TemplateFilters />
      </FiltersSection>
      <CardsSection>
        {loadingTemplates
          ? SKELETON_ITEMS.map((_, i) => (
              <Skeleton
                key={`template-skeleton-${i}`}
                height="128px"
                width="100%"
                borderRadius="8px"
              />
            ))
          : templates.map((template) => (
              <DashboardCard
                key={template.id}
                dashboard={template}
                onEdit={noop}
                onShare={noop}
                onArchive={noop}
                onDuplicate={noop}
              />
            ))}
      </CardsSection>
    </PageWrapper>
  );
};

export default TemplateList;
